<template>
<div>
  <Grid name="filterGridSO" ref="filterGridSO" v-bind:url="url" v-bind:columns="columns" :pageable='false' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload" v-bind:databound="dataBound"></Grid>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'SO',
  extends: BaseFilter,
  components: {
    Grid
  },
  data() {
    return {
      fieldName: 'ufs_salesteam_code',
      fieldLabel: 'Vendedor',
      gridRef: 'filterGridSO',
      preload: [],
      schemaModelFields: {},
      url: 'ufs_salesteam',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'ufs_salesteam_code',
        title: 'Código'
      }, {
        field: 'ufs_salesteam_name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// SellinSOFilter.vue?2422e637